import axios from 'axios'
import { relativeTimeThreshold } from 'moment/moment'
import { uuid } from 'vue-uuid'

let uuid_generate = uuid.v1()

function redireccionLogin(){
	let url_redireccion = ''
	if (process.env.NODE_ENV == 'production') {
		url_redireccion	= window.location.origin + '/SiUSR?continue=' + window.location.origin
	} else {
		url_redireccion	= 'http://localhost:8081/SiUSR?continue=http://localhost:8080'
	}
	window.location.href = url_redireccion
}

export {redireccionLogin}

let endpoints = null

const CancelToken = axios.CancelToken

export function getUrl () { return endpoints }

export function getCancelToken () { return CancelToken }

export async function init () {

	// Solo si la aplicacion esta instalada
	if (window.matchMedia('(display-mode: standalone)').matches) {
		
		localStorage.removeItem('uuid')
        localStorage.setItem('uuid', uuid_generate)
		setUUID(uuid_generate)
	}

	// Obtener distribucion app
	let distribution_app = await (await fetch(process.env.NODE_ENV === 'production' ? './js/distribution.json' : '/js/distribution.json')).json()
	window.distributionapp = distribution_app
	
	// Obtener configuracion
	let distribution_config = (await import( /* webpackIgnore: true */ process.env.NODE_ENV === 'production' ? `./${distribution_app.app}.js` : `./js/${distribution_app.app}.js`)).default
	window.distributionconfig = distribution_config

	endpoints = distribution_config.endpoints

	axios.defaults.headers.common['Token'] = 'Bearer ' + localStorage.getItem('accessToken')

	axios.defaults.headers.common['Device'] = localStorage.getItem('uuid')

	//axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

	axios.defaults.headers.common['Content-Type'] = 'application/json'

	//axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'

	axios.interceptors.request.use((config) => {
		return config
	})

	axios.interceptors.response.use(function (response) {

		return response

	}, function (error) {

		if (location.href.split('/')[location.href.split('/').length - 1] === 'login') return Promise.reject(error)

		if (error && error.response && 401 === error.response.status) {

			localStorage.removeItem('accessToken')
			//location.href = '/ficha'
			
			if (window.top !== window.self) {
				window.parent.postMessage('reloadwindow');
			} else {
				window.location.reload();
			}

		} else {

			return Promise.reject(error);

		}
	})
}

function queryParams(params) {
	return Object.keys(params).map(key => key + '=' + params[key]).join('&');
}

//<editor-fold desc="Config">
export function setHeader (key, value) { 
	axios.defaults.headers.common[key] = value
}
export function setToken (token) { axios.defaults.headers.common['Token'] = 'Bearer ' + token }
export function setUUID (uuid) { axios.defaults.headers.common['Uuid'] = uuid }
export function setDefaultsHeaders (entidad, id) { 
	
	axios.defaults.headers.common['Entidad'] = entidad

	if (id) axios.defaults.headers.common['Id'] = id
}
//</editor-fold>

export function previsualizarElemento (id, pagina) { return axios.get(`${url}elementos/${id}/previsualizar/${pagina}`) }

export function recargarPrevisualizarElemento (id, pagina) { return axios.get(`${url}elementos/${id}/recargarprevisualizar/${pagina}`) }

export function createValorLista (id) { return axios.post(`${url}listas/${id}/nuevoValor`) }

export function getValoresLista (id) { return axios.get(`${url}listas/valores/${id}`) }

export function login (data) { 
	return axios.post(`${endpoints.backend}login`, data) 
}
export function getUser () { return axios.get(`${endpoints.backend}datosUsuario`) }
export function recover (data) { return axios.post(`${url}recover`, data) }


function revisarurl(entidad, prefix, user) {
	
	// url = ${urlconfig}/ficha/estructura/${entidad}${filename}

	let filename = ''
	let config = window.distributionconfig

	if(config.configFiles == 'json'){
		if(config.typeRoles == "ROL"){
			let resultado = ''
			resultado += entidad ? `${entidad}.` : ''
			resultado += prefix ? `${prefix}.` : ''
			resultado += user.rol ? `${user.rol}.` : ''

			filename = `${resultado}json`
		}else{
			
			/*if(app.typeRoles== "USER"){
				filename = `.${user.id}.json`
			}else{
				filename = `.json`
			}*/
		}
	}else{
		filename = prefix && entidad ? `${prefix}/${entidad}` : `${entidad}`
	}
	
	console.log('filename: ', filename)
	
	return filename
}

export function getFichaEstructura (entidad, user) {
	return axios.get(`${endpoints.urlestructura}/${revisarurl(entidad, null, user)}`)
}
export function getFichaPersonalizacion (id,entidad) {
	return axios.get(`${endpoints.urlpersonalizacion.replace('@@entidad@@',entidad).replace('@@id@@',id)}`)
}

export function postSelectorEntidad (entidad, data) { return axios.post(`${endpoints.backend}selector/guardarDato/${entidad}`, data) }
export function getSelectorEstructura (entidadEditada) { return axios.get(`${endpoints.backend}selector/estructura/${entidadEditada}`) }
export function getSelectorDatos (entidadEditada, config) { return axios.post(`${endpoints.backend}selector/datos/${entidadEditada}`, config) }

export function getRelacionEstructura (entidad, relacion, user) {
	
	console.log('getRelacionEstructura: ', revisarurl(relacion, entidad, user))
	return axios.get(`${endpoints.urlRelacionEstructura}/${revisarurl(relacion,entidad, user)}`)
	// /relacion/estructura/${relacion}
}
export function getRelacionDatos (entidad, relacion, config) {
	
	if(window.distributionconfig.dataParams == 'formData'){

		// TEMPORAL PARA TRAER TABLA DE CERTIFICADOS
		if (relacion == 'certificados') {
			return axios({ method: "get", url: `${endpoints.backend}/listaFirmas.php`, data: formData })
		} else {
			var formData = new FormData();
			formData.append('tipo', relacion);
			return axios({ method: "post", url: `${endpoints.urlGetRelacionDatos}`, data: formData })
		}
		
	}else{
		return axios({ method: "post", url: `${endpoints.urlGetRelacionDatos}${revisarurl(relacion, entidad)}`, data: config })
	}
}

export function getBuscadorEstructura (entidad, relacion, user) {
	console.log('################### getBuscadorEstructura', entidad)
	return axios.get(`${endpoints.urlBuscadorEstructura}/${revisarurl(relacion, null, user)}`, {headers: {'Entidad': entidad}})
	// buscador/estructura/${relacion} 
}
export function getBuscadorCuadroMandosEstructura (relacion, user) {
	//return axios.get(`${endpoints.urlBuscadorEstructura}/${revisarurl(relacion, null, user)}`)
	return axios.get(`${endpoints.backend}cuadromando/estructura/${relacion}`)
	// buscador/estructura/${relacion} 
}


export function getBuscadorDatos (entidad, entidadEditada, config) {
	console.log('##############################getBuscadorDatos',entidad)

	return axios.post(`${endpoints.backend}buscador/datos/${entidadEditada}`, config, {headers: {'Entidad': entidad }}) 
}
export function getBuscadorDatosCuadroMandos (entidadEditada, config) { 
	return axios.post(`${endpoints.backend}cuadromando/datos/${entidadEditada}`, config) 
}
export function updateInput (data) { return axios.post(`${endpoints.backend}input`, data) }
export function updateInputFile (data, dato) {
	return axios.post(`${endpoints.backend}input?${queryParams(dato)}`, data, {
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	})
}

export function getSelectInput (entidad) { return axios.get(`${endpoints.backend}input/select/${entidad}`) }

export function postAction(action, metodo, data) {
	if (metodo.toLowerCase() == 'post') {
		return axios.post(`${endpoints.backend}${action}`, data)
	} else {
		return axios.get(`${endpoints.backend}${action}${queryParams(data).length ? `?${queryParams(data)}` : ''}`)
	}
}
export function postActionData(action,data, metodo) { return axios[metodo](`${endpoints.postActionData}/${action}`, data) }

export function getInforme(nombre, tipo, config) { return axios.get(`${endpoints.backend}informe/${nombre}/${tipo}?${queryParams(config)}`) }
export function getDocumentos() { return axios.get(`${endpoints.backend}documento/lista`) }

export function getGraficaDatos(entidad) { return axios.get(`${endpoints.backend}grafica/${entidad}`) }

export function getBuscadorFiltrosEstructura() { return axios.get(`${endpoints.backend}buscador/estructura`) }

export function getActividad() { return axios.get(`${endpoints.backend}actividad`) }

export function getValoresListasimple (data) { return axios.post(`${endpoints.backend}listasimple/${data}`) }

//Calendario
export function getCalendarioEstructura() { return axios.get(`${endpoints.backend}calendario/estructura`) }
export function getCalendarioDatos() { return axios.get(`${endpoints.backend}calendario/datos`) }
export function guardarSolicitud({param, data}) { return axios.post(`${endpoints.backend}${param}`, data)}

// Boton informes de tabla
export function getTableInforme({data, entidad}) { return axios.post(`${endpoints.backend}buscador/informe/${entidad}`, data) }
export function getTableInformeCuadromando({data, entidad}) { return axios.post(`${endpoints.backend}cuadromando/informe/${entidad}`, data) }

// Componente Form (Formulario dinamico) 
export function getEstructuraFormulario(entidad, user) {
	return axios.get(`${endpoints.urlEstructuraFormulario}/${revisarurl(entidad, 'form', user)}`)
}

// Obtener dashboard
export function getDashboard() {
	return axios({ method: "get", url: `${endpoints.urlDashboard}`})
}

// Obtener control de trabajos
export function getDataControlTrabajo() {
	return axios({ method: "get", url: `${endpoints.urlControlTrabajo}`})
}
export function postDataControlTrabajo(data) {
	return axios({ method: "post", url: `${endpoints.urlControlTrabajo}`, data})
}

// PETICIONES PARA FIRMAR DOCUMENTOS

// Lista documentos pdf
export function getListaDocumentosPdf(formData) {
	console.log('getListaDocumentosPdf')
	return axios({ method: "post", url: `${endpoints.backend}/listaDocumentos.php`, data: formData })
}

// Obtener base64 de un archivo
export function getDocumentoPDF (formData) { 
	return axios({ method: "post", url: `${endpoints.urlDocumentoPDF}`, data: formData })
}

// Login especial para app de documentos
export function loginDocumentos (formData) { return axios({ method: "post", url: `${endpoints.backend}/login.php`, data: formData }) }


// Obtener un json  de la carpeta jsonDocumentos
export function fetchJSON (url) { 
	return axios({ method: "get", url: `${endpoints.backendjson}/${url}` }) 
}

// Obtener datos de una url completamente externa
export function fetchURL (url) { 
	return axios({ method: "get", url: `${endpoints.backend}/${url}` }) 
}

// Obtener imagenes de firmas para firmar
export function getFirmarImagenes (data) {
	return axios({ method: "post", url: `${endpoints.urlImagenesFirmar}`, data})
}

// Obtener valores de HTML en porletCompiled
export function getDataCompiled (entidadRelacionada) { 
	return axios.post(`${endpoints.backend}porletCompiled/${entidadRelacionada}`,'',{
		headers: {
			'Content-Type': 'application/json'
		}
	})
}